import { Environment } from '@zippie/did-core'

export const ZIPPIE_URL = {
  [Environment.localhost]: 'https://dev.zippie.com',
  dev2: 'https://dev.zippie.com',
  dev3: 'https://dev.zippie.com',
  [Environment.dev]: 'https://dev.zippie.com',
  [Environment.test]: 'https://testing.zippie.com',
  [Environment.prod]: 'https://zippie.com',
}
/* TODO replace the invitation link below with a proper link for AirImpact */
// https://dashboard.dev.airimpact.co/invite/02c2a961ad6f8bf260f0b38012c8e7fad9671121e3793f1615541d8d1385d5b3
export const BACKEND_URL = {
  [Environment.localhost]: 'https://api.dev.airimpact.co/api',
  dev2: 'https://api2.dev.airimpact.co/api',
  dev3: 'https://api3.dev.airimpact.co/api',
  [Environment.dev]: 'https://api.dev.airimpact.co/api',
  [Environment.test]: 'https://api.test.airimpact.co/api',
  [Environment.prod]: 'https://api.airimpact.co/api',
}

export const BACKEND = 'https://api.dev.airimpact.co'
